<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :destroyOnClose="true" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        选择题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="正确顺序选项">
            <a-row v-for="(answer, answerIndex) in drill.correctAnswerList" :key="answerIndex" style="margin-top: 32px;">
              <a-row>
                选项{{ answerIndex + 1 }}: <a-input style="width: 80%" v-model="answer.text" placeholder="请输入选项文字"/>
                <a-icon
                  v-if="drill.correctAnswerList.length > 1"
                  class="dynamic-delete-button"
                  type="minus-circle-o"
                  @click="removeAnswer(answerIndex)"/>
              </a-row>
            </a-row>
            <a-button type="dashed" style="width: 100%" @click="() => addAnswer()">
              <a-icon type="plus" />增加选项
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import SequencingDrillApi from '../../../../api/src/drill/api/SequencingDrillApi.js'
const sequencingDrillApi = new SequencingDrillApi()
import CommonUpload from '../../../../components/CommonUpload.vue'
import AudioUpload from '../../../../components/AudioUpload.vue'

import { deepClone } from '@clownlee/utils'

export default {
  name: "SequencingDrillEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {CommonUpload, AudioUpload},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await sequencingDrillApi.getDetail(this.currentDrillId)
        console.log(resp)
        resp.correctAnswerList = resp.correctAnswer.map(item => {
          return {
            text: item
          }
        })
        this.drill = resp
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        required: false,
        text: undefined,
        audioUri: undefined,
        optionList: [],
        correctAnswer: [],
        correctAnswerList: [],
        explanation: undefined
      },
      fragmentList: [],
      uploading: false,
      loading: false,
      visible: false
    }
  },
  methods:{
    addAnswer() {
      let correctAnswerList = deepClone(this.drill.correctAnswerList)
      correctAnswerList.push({
        text: undefined
      })
      this.drill.correctAnswerList = correctAnswerList
    },
    removeAnswer(answerIndex) {
      let correctAnswerList = deepClone(this.drill.correctAnswerList)
      correctAnswerList.splice(answerIndex, 1)
      this.drill.correctAnswerList = correctAnswerList
    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        audioUri: undefined,
        optionList: [],
        correctAnswer: [],
        correctAnswerList: [],
        explanation: undefined
      }
    },
    async handleOk() {
      let drill = deepClone(this.drill)
      console.log(drill)
      if(!drill.correctAnswerList || drill.correctAnswerList.length <= 1){
        this.$message.error('请填写选项')
        return
      }
      drill.correctAnswer = drill.correctAnswerList.map(item => {return item.text})
      drill.optionList = drill.correctAnswerList.sort(item => {
        return Math.random() - 0.5
      }).map(item => {return item.text})
      if(!drill.id){
        drill.subType = this.subType
      }
      drill.text = drill.correctAnswer.join('|')
      console.debug(drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!drill.id){
        await sequencingDrillApi.create(drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await sequencingDrillApi.update(drill.id, drill)
      }
      this.visible = false
      this.drill = {
        required: false,
        text: undefined,
        audioUri: undefined,
        optionList: [],
        correctAnswer: [],
        correctAnswerList: [],
        explanation: undefined
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    }
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>